export const GROUND_FACES_PRIORITY = 3;
export const REGULAR_FACES_PRIORITY = 2;
export const DETAIL_FACES_PRIORITY = 1;
export const PROPS_FACES_PRIORITY = 0;

export const POLYGON_OFFSET_FOR_UNION = 0.05;
export const POLYGON_OFFSET_FOR_CROSS_SECTION_UNION = 0.0125;

export const PERSPECTIVE_DRAWING_VERTICAL_FOV_MAX = 100; // Don't expand FOV above 100 degrees to avoid distorted renderings.

export const PERSPECTIVE_DRAWING_AUTO_CROP_DEFAULT_MARGIN = 0.5; // inches
export const PERSPECTIVE_DRAWING_AUTO_CROP_DEFAULT_FRACTIONAL_PADDING = 0.05; // fraction of building height
